import { Component } from '@angular/core';
import { ProviderListComponent } from './provider-list.component';

@Component({
  selector: 'app-view-sso-settings',
  templateUrl: './view-sso-settings.component.html',
  styleUrls: ['./provider-list.component.less']
})

export class ViewSSOSettingsComponent extends ProviderListComponent {}


// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/auth-settings/view-sso-settings.component.ts